export const AGE_RANGE_OPTIONS = [
  {
    label: '5_to_11',
    value: '5 to 11',
  },
  {
    label: '12_to_14',
    value: '12 to 14',
  },
  {
    label: '15_to_18',
    value: '15 to 18',
  },
  {
    label: '19_and_above',
    value: '19 and above',
  },
]
